<template>
  <div class="component-container">
    <h1>Portfolio</h1>
    <div class="gallery">
      <div class="image-container">
        <div class="aspect-ratio-box">
          <img src="../assets/velomech.png" />
          <div class="image-overlay">
            <div class="image-description">
              <div class="image-title">Velomech</div>
              <p>
                This web application is a website designed for a bicycle shop.
                The website provides a clear overview of services and current
                bicycle offers. For easy administration, I implemented a custom
                admin area secured with JWT authentication, which allows simple
                editing of the offers.
              </p>
              <div class="listing">
                <div class="listing-item">
                  Deployment: Google Cloud Run
                  <br />
                  Containerization: Docker
                </div>
                <div class="listing-item">
                  Frontend: Vue, tailwindcss
                  <br />
                  Backend: Python - Flask
                  <br />
                  Database: Firestore
                </div>
              </div>
              <div class="button">
                <button @click="openVelomechUrl">Visit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="image-container">
        <div class="aspect-ratio-box">
          <img src="../assets/tschira.png" />
          <div class="image-overlay">
            <div class="image-description">
              <div class="image-title">Tschira</div>
              <p>
                This web app is a Jira-inspired task manager with drag-and-drop
                functionality and WebSocket integration. It allows simultaneous
                collaboration with live updates.
              </p>
              <div class="listing">
                <div class="listing-item">
                  Deployment: Google Cloud Run
                  <br />
                  Containerization: Docker
                </div>
                <div class="listing-item">
                  Frontend: React, tailwindcss
                  <br />
                  Backend: Python - Flask - SocketIO
                  <br />
                  Database: Firestore
                </div>
              </div>
              <div class="button">
                <button @click="openTschiraUrl">Visit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="image-container">
        <div class="aspect-ratio-box">
          <img src="../assets/pollmaker.png" />
          <div class="image-overlay">
            <div class="image-description">
              <div class="image-title">Poll Maker</div>
              <p>
                This is a small web app to create polls. The polls can be filled
                in and reviewed in the web app.
              </p>
              <div class="listing">
                <div class="listing-item">
                  Deployment: Google Cloud Run
                  <br />
                  Containerization: Docker
                </div>
                <div class="listing-item">
                  Frontend: React
                  <br />
                  Backend: Python - Flask
                  <br />
                  Database: Firestore
                </div>
              </div>
              <div class="button">
                <button @click="openPollMakerUrl">Visit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="image-container">
        <div class="aspect-ratio-box">
          <img src="../assets/portfolio.png" />
          <div class="image-overlay">
            <div class="image-description">
              <div class="image-title">Portfolio</div>
              <p>
                This site showcases my web projects with a focus on
                responsiveness across various devices.
              </p>
              <div class="listing">
                <div class="listing-item">
                  Deployment: Google Cloud Run
                  <br />
                  Containerization: Docker
                </div>
                <div class="listing-item">
                  Frontend: Vue
                  <br />
                  Backend: Python - Flask
                  <br />
                  Database: Firestore
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="image-container">
        <div class="aspect-ratio-box">
          <img src="../assets/jsgame.png" />
          <div class="image-overlay">
            <div class="image-description">
              <div class="image-title">Jump and Run Game</div>
              <p>
                A simple jump and run game created entirely in Javascript using
                canvas animations.
              </p>
              <div class="listing">
                <div class="listing-item">
                  Deployment: Google Cloud Run
                  <br />
                  Containerization: Docker
                </div>
                <div class="listing-item">
                  JavaScript
                  <br />
                  HTML
                  <br />
                  CSS
                </div>
              </div>
              <div class="button">
                <button @click="openJSGameUrl">Visit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="image-container"></div>
    </div>
    <div class="glossary">
      <h2>Glossary</h2>
      <p>
        <strong>React:</strong> A JavaScript library for building user
        interfaces, particularly for single-page applications where UI updates
        are dynamic.
      </p>
      <p>
        <strong>Vue:</strong> A JavaScript framework for building user
        interfaces. Vue is known for its simplicity and flexibility.
      </p>
      <p>
        <strong>Python - Flask:</strong> Flask is a micro web framework written
        in Python. It's lightweight and designed to be easy to use and extend.
      </p>
      <p>
        <strong>Firestore:</strong> A NoSQL document database provided by
        Firebase and part of the Google Cloud platform. It allows for real-time
        data synchronization and efficient queries.
      </p>
      <p>
        <strong>Google Cloud Run:</strong> A fully managed compute platform that
        automatically scales containers. It's part of Google Cloud's serverless
        offerings.
      </p>
      <p>
        <strong>Docker:</strong> A platform for developing, shipping, and
        running applications in containers. Containers allow you to package an
        application with all its dependencies.
      </p>
      <p>
        <strong>WebSocket:</strong> A communication protocol that provides
        full-duplex communication channels over a single, long-lived connection.
        It is commonly used for real-time web applications.
      </p>
      <p>
        <strong>Tailwind CSS:</strong> A utility-first CSS framework that
        provides low-level utility classes to build designs directly in your
        markup. It offers a highly customizable and efficient way to style web
        applications.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PortfolioScreen",
  methods: {
    openJSGameUrl() {
      window.open("https://jsgame-xozigkufta-ew.a.run.app", "_blank");
    },
    openPollMakerUrl() {
      window.open("https://pollmaker-xozigkufta-ew.a.run.app", "_blank");
    },
    openTschiraUrl() {
      window.open("https://tschira-xozigkufta-ew.a.run.app", "_blank");
    },
    openVelomechUrl() {
      window.open("https://velomech-xozigkufta-ew.a.run.app", "_blank");
    },
  },
};
</script>

<style scoped>
.gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 20px;
}

.image-container {
  position: relative;
  margin: 20px 50px 20px;
  overflow: hidden;
  width: calc(50% - 100px);
  max-width: 700px;
  min-width: 275px;
}

.image-container img {
  width: 100%;
  height: auto;
  display: block;
  transition: filter 0.3s ease-in-out;
}

.image-container:hover img {
  filter: blur(3px);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: #92c7cf;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  cursor: pointer;
}

.image-container:hover .image-overlay {
  opacity: 0.9;
}

.image-description {
  margin: 10px;
  text-align: left;
}

.image-title {
  font-size: 1.2em;
  font-weight: bold;
  text-align: center;
  margin-bottom: 5px;
}

.listing {
  display: flex;
  margin-bottom: 5px;
}

.listing-item {
  flex: 1;
  margin-right: 10px;
}

.aspect-ratio-box {
  aspect-ratio: 4 / 3;
}

.aspect-ratio-box img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.glossary p {
  text-align: left;
}

.button {
  display: flex;
  justify-content: center;
  padding-top: 2rem;
}

@media screen and (max-width: 600px) {
  .image-container {
    margin: 10px 20px 10px;
    width: calc(100% - 10px);
  }
}
@media screen and (min-width: 601px) and (max-width: 1024px) {
  .image-container {
    margin: 15px 40px 15px;
    width: calc(100% - 10px);
  }
}
</style>
